import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';
import { StateService } from '../../../core/services/state.service';
import { BusinesscoItem, LogisticService } from '../../../services/logistic.service';

@Component({
  selector: 'tt-p2-terminal',
  templateUrl: './p2-terminal.component.html',
  styleUrls: ['./p2-terminal.component.css']
})
export class P2TerminalComponent implements OnInit {
    public p2TerminalKeyno;

    public edit?: Edit;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListTerminalTypes: TerminalTypeItem[] = [];

    public selectListEquipments: Item[] = [];

    public selectListNotificationTypes: NotificationTypeItem[] = [];

    public selectListPartDeliveryTypes: PartDeliveryTypeItem[] = [];

    public saving = false;

    public deleting = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService, private logistic: LogisticService) {
        this.p2TerminalKeyno = this.stateService.getStateParams()['p2_terminal_keyno'];
    }

    private async loadEdit() {
        if (!!this.p2TerminalKeyno) {
            this.edit = (await this.datatask.Post(342, { p2_terminal_keyno: this.p2TerminalKeyno }))[0];
        }
    }

    private async loadCompanies(): Promise<void> {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadTerminalTypes(): Promise<void> {
        this.selectListTerminalTypes = await this.datatask.Post(429);
    }

    private async loadEquipments(): Promise<void> {
        this.selectListEquipments = await this.logistic.getEquipments();
    }

    private async loadNotificationTypes(): Promise<void> {
        this.selectListNotificationTypes = await this.datatask.Post(430);
    }

    private async loadPartDeliveryTypes(): Promise<void> {
        this.selectListPartDeliveryTypes = await this.datatask.Post(431);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(343, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    public async deleteValues() {
        if (!!this.edit) {
            try {
                this.deleting = true;

                const deleteConfirmed = await this.modal.openConfirmDialog({
                    title: 'confirm_title',
                    translateMessage: true,
                    message: 'confirm_message',
                    type: 'danger'
                });

                if (deleteConfirmed) {
                    await this.datatask.Post(344, { p2_terminal_keyno: this.edit.p2_terminal_keyno });

                    this.stateService.back();
                }
            } finally {
                this.deleting = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
        this.loadCompanies();
        this.loadTerminalTypes();
        this.loadEquipments();
        this.loadNotificationTypes();
        this.loadPartDeliveryTypes();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    p2_terminal_keyno: number;
    terminal_name: string;
    businessco_no: number;
    regby_portal_user_name: string;
    reg_datetime: string;
    terminal_description: string;
    supplier_no: number;
    terminaltype_id: string;
    notificationtype_id: string;
    partdeliverytype_id: string;
    portal_user_keyno: string;
    equipment_id: string;
}

interface TerminalTypeItem {
    terminaltype_id: string;
    terminaltype_name: string;
    orderby: number;
}

interface NotificationTypeItem {
    notificationtype_id: string;
    notificationtype_name: string;
    orderby: number;
}

interface PartDeliveryTypeItem {
    partdeliverytype_id: string;
    partdeliverytype_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('p2Terminal', {
//        templateUrl: 'views/components/views/p2Terminal/p2Terminal.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'translateService', 'modalService', 'p2TerminalService', 'logisticService', function ($stateParams, stateService, translateService, modalService, p2TerminalService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let p2TerminalKeyno = $stateParams.p2_terminal_keyno;

//            let translations = {
//                confirm_title: '',
//                confirm_message: '',
//                confirm_ok_label: '',
//                confirm_cancel_label: '',
//                error: '',
//                ok: ''
//            };

//            vm.model = {
//                p2TerminalKeyno: p2TerminalKeyno,
//                edit: {},
//                selectListCompanies: [],
//                selectListTerminalTypes: [],
//                selectListEquipments: [],
//                selectListNotificationTypes: [],
//                selectListPartDeliveryTypes: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region TRANSLATE SERVICE

//            translateService.translateBatch(translations).then(function (data) {
//                angular.forEach(translations, function (_, key) {
//                    if (angular.isDefined(data[key])) {
//                        translations[key] = data[key];
//                    }
//                });
//            });

//            // #endregion TRANSLATE SERVICE

//            // #region LOAD PROCEDURE CALLS

//            let loadEdit = function () {
//                p2TerminalService.getEdit({ p2_terminal_keyno: p2TerminalKeyno }).then(function (info) {
//                    angular.copy(info[0], vm.model.edit);
//                });
//            };

//            let loadCompanies = function () {
//                logisticService.listCompanies().then(function (list) {
//                    angular.copy(list, vm.model.selectListCompanies);
//                });
//            };

//            let loadTerminalTypes = function () {
//                p2TerminalService.listTerminalTypes().then(function (list) {
//                    angular.copy(list, vm.model.selectListTerminalTypes);
//                });
//            }

//            let loadEquipments = function () {
//                logisticService.listEquipments().then(function (list) {
//                    angular.copy(list, vm.model.selectListEquipments);
//                });
//            };

//            let loadNotificationTypes = function () {
//                p2TerminalService.listNotificationTypes().then(function (list) {
//                    angular.copy(list, vm.model.selectListNotificationTypes);
//                });
//            };

//            let loadPartDeliveryTypes = function () {
//                p2TerminalService.listPartDeliveryTypes().then(function (list) {
//                    angular.copy(list, vm.model.selectListPartDeliveryTypes);
//                });
//            };

//            // #region LOAD PROCEDURE CALLS

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                p2TerminalService.saveObj(vm.model.edit).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            };

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

//            vm.deleteValues = function () {
//                vm.model.lockedDelete = true;

//                modalService.confirm({
//                    type: 'danger',
//                    title: translations.confirm_title,
//                    message: translations.confirm_message,
//                    okLabel: translations.confirm_ok_label,
//                    cancelLabel: translations.confirm_cancel_label
//                }).then(function () {
//                    p2TerminalService.deleteItem({ p2_terminal_keyno: vm.model.edit.p2_terminal_keyno }).then(function () {
//                        vm.model.lockedDelete = false;
//                        stateService.back();
//                    }, function () {
//                        vm.model.lockedDelete = false;
//                    });
//                }, function () {
//                    vm.model.lockedDelete = false;
//                });
//            };

//            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadEdit();
//                loadCompanies();
//                loadTerminalTypes();
//                loadEquipments();
//                loadNotificationTypes();
//                loadPartDeliveryTypes();
//            };

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
